(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initLogoSlider() {
    $('.icon-collection-slider__track').each(function () {
      var $slider = $(this);

      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }

var desktopSlides = parseInt($slider.attr('data-desktop'), 10) || 6;
var mobileSlides = parseInt($slider.attr('data-mobile'), 10) || 2;
      var arrowsEnabled = $slider.data('arrows') === true || $slider.data('arrows') === 'true';

      $slider.slick({
        mobileFirst: true,
        slidesToShow: mobileSlides,
        slidesToScroll: 1,
        arrows: arrowsEnabled,
        dots: false,
        infinite: true,
        autoplay: true,
autoplaySpeed: 2000,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: desktopSlides
            }
          }
        ]
      });
    });
  }

  // Normal load
  $(document).ready(initLogoSlider);

  // Shopify theme editor reload
  document.addEventListener('shopify:section:load', initLogoSlider);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-grid-and-slider"] && !Shopify.designMode) return;
  try {
    
(function ($) {

  function initIconMediaSlider() {

    $('.icon-media-slider__track').each(function () {
      var $slider = $(this);

      // Slider disabled → grid mode
      if (!$slider.data('desktop')) return;

      // Prevent duplicate init
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }

      var desktopSlides = parseInt($slider.data('desktop')) || 4;
      var mobileSlides  = parseInt($slider.data('mobile')) || 1;
      var arrowsEnabled = $slider.data('arrows') === true || $slider.data('arrows') === 'true';

      $slider.slick({
        mobileFirst: true,
        slidesToShow: mobileSlides,
        slidesToScroll: 1,
        arrows: arrowsEnabled,
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: desktopSlides
            }
          }
        ]
      });
    });

    // Fancybox (safe init)
    if ($.fn.fancybox) {
      $('[data-fancybox]').fancybox({
        loop: true,
        buttons: ['close'],
        animationEffect: 'zoom'
      });
    }
  }

  // Normal load
  $(document).ready(initIconMediaSlider);

  // Shopify theme editor reload
  document.addEventListener('shopify:section:load', initIconMediaSlider);

})(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initLogoSlider() {
    $('.logo-slider').each(function () {
      var $slider = $(this);

      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }

      var desktopSlides = parseInt($slider.data('desktop-slides')) || 5;
      var mobileSlides = parseInt($slider.data('mobile-slides')) || 2;
      var arrowsEnabled = $slider.data('arrows') === true || $slider.data('arrows') === 'true';

      $slider.slick({
        mobileFirst: true,
        slidesToShow: mobileSlides,
        slidesToScroll: 1,
        arrows: arrowsEnabled,
        dots: false,
        infinite: true,
        autoplay: $slider.data('autoplay') === true || $slider.data('autoplay') === 'true',
        autoplaySpeed: parseInt($slider.data('speed')) || 3000,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: desktopSlides
            }
          }
        ]
      });
    });
  }

  // Normal load
  $(document).ready(initLogoSlider);

  // Shopify theme editor reload
  document.addEventListener('shopify:section:load', initLogoSlider);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-block"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initLogoSlider() {
    $('.icon-product-slider__track').each(function () {
      var $slider = $(this);

      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }

      var desktopSlides = parseInt($slider.data('desktop')) || 5;
      var mobileSlides = parseInt($slider.data('mobile')) || 2;
      var arrowsEnabled = $slider.data('arrows') === true || $slider.data('arrows') === 'true';

      $slider.slick({
        mobileFirst: true,
        slidesToShow: mobileSlides,
        slidesToScroll: 1,
        arrows: arrowsEnabled,
        dots: false,
        infinite: true,
        autoplay: $slider.data('autoplay') === true || $slider.data('autoplay') === 'true',
        autoplaySpeed: parseInt($slider.data('speed')) || 3000,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: desktopSlides
            }
          }
        ]
      });
    });
  }

  // Normal load
  $(document).ready(initLogoSlider);

  // Shopify theme editor reload
  document.addEventListener('shopify:section:load', initLogoSlider);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  $('.testimonial-slider').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 }
      },
      {
        breakpoint: 600,
        settings: { slidesToShow: 1 }
      }
    ]
  });
});

  } catch(e) { console.error(e); }
})();
})();
